import { Box, Container, Text, Button, useBreakpointValue, VStack, HStack, useToast } from '@chakra-ui/react'
import dayjs from 'dayjs'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useCreateRoomReservationMutation } from '../../hooks/coreApi/useRoomReservations'
import { useReservation } from './ReservationContext'
import ReservationInfoPanel from './ReservationInfoPanel'

const ReservationCreateConfirm: React.FC = () => {
  const { state, goBack } = useReservation()
  const isMobile = useBreakpointValue({ base: true, md: false })
  const createRoomReservationMutation = useCreateRoomReservationMutation();
  const navigate = useNavigate();
  const toast = useToast();

  const handleConfirm = () => {
    if (!state.roomId) {
      toast({
        title: '部屋を選択してください',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      })
      return;
    }

    if (!state.title) {
      toast({
        title: '会議名を入力してください',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      })
      return;
    }

    if (!state.date || !state.startTime || !state.endTime) {
      toast({
        title: '日付と時間を選択してください',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      })
      return;
    }
    
    // 日付と時間を結合してISOフォーマットに変換
    const startDateTime = dayjs(`${state.date} ${state.startTime}`).toISOString();
    const endDateTime = dayjs(`${state.date} ${state.endTime}`).toISOString();

    createRoomReservationMutation.mutate({
      roomReservationCreateRequest: {
        roomId: state.roomId,
        title: state.title,
        startTime: startDateTime,
        endTime: endDateTime,
        password: state.password,
      }
    }, {
      onSuccess: () => {
        toast({
          title: '予約が完了しました',
          status: 'success',
          duration: 3000,
        })
        navigate('/video/group/my-reserved-rooms')
      },
      onError: () => {
        toast({
          title: '予約に失敗しました',
          status: 'error',
          duration: 3000,
        })
      }
    })
  }

  return (
    <Box
      pt={isMobile ? '0px' : '24px'}
      pb={isMobile ? '0px' : '110px'}
      backgroundColor="grand.white"
      px={isMobile ? '16px' : '0px'}
      w="100%"
      maxW="100vw"
    >
      <Container maxW={isMobile ? "100%" : "container.sm"} px={isMobile ? 0 : 4} w="100%">
        <VStack spacing={6} align="stretch" width="100%" maxW="100%">
          <Text fontSize="20px" fontWeight="700" wordBreak="break-word" whiteSpace="normal">
            予約内容の確認
          </Text>
          
          <Box w="100%" maxW="100%">
            <ReservationInfoPanel showTitle showPassword />
          </Box>
          
          {isMobile ? (
            <VStack spacing={3} mt={4} w="100%">
              <Button onClick={goBack} size="md" width="100%" variant="outline">戻る</Button>
              <Button colorScheme="green" onClick={handleConfirm} size="md" width="100%">
                予約を確定する
              </Button>
            </VStack>
          ) : (
            <HStack justify="space-between" mt={4} w="100%">
              <Button onClick={goBack} size="md">戻る</Button>
              <Button colorScheme="green" onClick={handleConfirm} size="md">
                予約を確定する
              </Button>
            </HStack>
          )}
        </VStack>
      </Container>
    </Box>
  )
}

export default ReservationCreateConfirm 